import { Module, ActionContext } from 'vuex'
import { RootState, WorkflowState } from './state_models'
import { Workflow } from '../models'
import { WorkflowsResellingService } from '../services'

export const workflows: Module<WorkflowState, RootState> = {
  namespaced: true,
  state: {
    workflows: [],
    locationId: undefined,
    isWorkflowResellingEnabled: false,
    locationWorkflowResellingEnabling: {},
  },
  getters: {
    getById: (state: WorkflowState) => {
      return (id: string) => state.workflows.find(x => x.id === id)
    },
    getAll: (state: WorkflowState) => {
      return state.workflows
    },
  },
  mutations: {
    addUpdate: (state: WorkflowState, payload: { workflows: any; locationId: string }) => {
      state.workflows = payload.workflows
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    clearAll: (state: WorkflowState) => {
      state.workflows = []
      state.locationId = undefined
    },
    updateWorkflowResellingEnabling: (state: WorkflowState, payload: { value: boolean }) => {
      state.isWorkflowResellingEnabled = payload.value as boolean
    },
    updateLocationWiseEnabling: (state: WorkflowState, payload: { locationId: string; enabled: boolean }) => {
      state.locationWorkflowResellingEnabling[payload.locationId] = payload.enabled
    },
  },
  actions: {
    async syncAll(context: ActionContext<WorkflowState, RootState>, locationId: string) {
      if (!locationId) {
        context.commit('clearAll')
        return
      }

      if (context.state.locationId === locationId) {
        return context.state.workflows
      }

      context.commit('clearAll')

      return new Promise(async (resolve) => {
        try {
          const workflows = await Workflow.getWithLocationId(locationId)

          context.commit('addUpdate', {
            locationId,
            workflows,
          })
          resolve(context.state.workflows)
        } catch {
          resolve([])
        }
      })
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<WorkflowState, RootState>) => {
        context.commit('clearAll')
      },
    },
    clearAll: {
      handler: async (context: ActionContext<WorkflowState, RootState>) => {
        context.commit('clearAll')
      },
    },
    async getProduct() {
      try {
        const res = await WorkflowsResellingService.getProductConfiguration()
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getCompanySubscriptions(context: ActionContext<WorkflowState, RootState>) {
      try {
        const companyId = context.rootState?.company.company.id as string
        const res = await WorkflowsResellingService.getCompanySubscriptions(companyId)

        const locationSubscriptions = res.filter(item => item.productCode === WorkflowsResellingService.PRODUCT_ID)
        return Promise.resolve(locationSubscriptions)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getLocationSubscriptions(context: ActionContext<WorkflowState, RootState>) {
      try {
        const locationId = context.rootState?.locations.currentLocation.id as string
        const res = await WorkflowsResellingService.getLocationSubscriptions(locationId)
        const locationSubscriptions = res.filter(
          item => item.productCode === WorkflowsResellingService.PRODUCT_ID && item.paymentStatus == 'COMPLETE'
        )

        return Promise.resolve(locationSubscriptions)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    changeWorkflowResellingEnabling: {
      handler: async (context: ActionContext<WorkflowState, RootState>, payload: { value: boolean }) => {
        context.commit('updateWorkflowResellingEnabling', payload)
      },
    },
    async getCompanyResellingConfig(context: ActionContext<WorkflowState, RootState>) {
      try {
        const companyId = context.rootState?.company.company.id as string
        const res = await WorkflowsResellingService.getCompanyResellingConfig(companyId)
        console.log('res', res)
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
